import React, { useCallback } from 'react';
import { checkValueRange, FilterBaseComposition } from './FilterBase';
import styles from 'styles/partials/_filterbigdecimal.css';
import getValue from 'components/connectedForm/utils/getValue';
import Dropdown from 'components/connectedForm/Dropdown';
import fieldMetaData from 'graphql/schema/fieldMetaData';
import { BlurTextField } from '../connectedForm/inputComponents';
import { BlurTextFieldType } from '../connectedForm/BlurTextField/BlurTextField';
import { FilterNumberType } from '../../graphql/schema/p4types';
import TextArea from '../connectedForm/TextArea';

const getDescription = (committedValues, filterValues) => {
  const { from: fromAmount, to: toAmount, filterType } = committedValues;

  if (filterType === 'RANGE' && fromAmount && toAmount) {
    return `${fromAmount} - ${toAmount}`;
  }
  let description = 'All';
  switch (filterType) {
    case 'EQUALS':
      description = `= ${fromAmount}`;
      break;
    case 'NOT_EQUALS':
      description = `<> ${fromAmount}`;
      break;
    case 'LESS_THAN':
      description = `< ${fromAmount}`;
      break;
    case 'LESS_THAN_EQUAL':
      description = `<= ${fromAmount}`;
      break;
    case 'GREATER_THAN':
      description = `> ${fromAmount}`;
      break;
    case 'GREATER_THAN_EQUAL':
      description = `>= ${fromAmount}`;
      break;
    case 'IN':
      description = `IN (${fromAmount}'`;
      break;
  }
  return description;
};

const FilterBigDecimalComposition = (props) => {
  //TODO - Revise deps for getQueryFilters
  const getQueryFilters = useCallback(
    (committedValues, filterValues) => {
      const queryFilters = [];
      if (filterValues.from) {
        queryFilters.push({
          fieldName: props.fieldName,
          operation: '>=',
          value: filterValues.from,
        });
      }
      if (filterValues.to) {
        queryFilters.push({
          fieldName: props.fieldName,
          operation: '<=',
          value: filterValues.to,
          includeNull: !filterValues.from,
        });
      }

      return queryFilters;
    },
    [props.fieldName]
  );

  const renderPopout = (setInputRef, filterValues, handleChange) => {
    const messages = checkValueRange(filterValues);
    const { filterType, from: fromAmount, to: toAmount } = filterValues;

    return (
      <div className={styles.container}>
        <Dropdown
          autoFocus={true}
          id="filterType"
          setInputRef={setInputRef}
          label="Type"
          onChange={(value) => handleChange('filterType', getValue(value))}
          enum={true}
          options={fieldMetaData.FilterNumberType.enumValues}
          value={filterType}
          menuContainerStyle={{ maxWidth: '210px' }}
        />
        <BlurTextField
          id="from"
          label={filterType && filterType !== 'RANGE' ? 'Number' : 'From'}
          value={fromAmount}
          onChange={(value) => handleChange('from', value)}
          enableOnChange={true}
          type={filterType === FilterNumberType.In ? BlurTextFieldType.TextArea : undefined}
          clearable={filterType === FilterNumberType.In ? true : undefined}
          hint={
            filterType === FilterNumberType.In ? (
              <div>
                Enter values seperated by a comma, space or new-lines. Any (exact) matches will be included in the
                results.
                <br />
                <br />
                {'E.g. "2200, 2205, 2358"'}
              </div>
            ) : undefined
          }
        />
        {filterType && filterType === 'RANGE' ? (
          <BlurTextField
            id="to"
            label="To"
            value={toAmount}
            onChange={(value) => handleChange('to', value)}
            message={messages}
            enableOnChange={true}
          />
        ) : null}
      </div>
    );
  };

  return (
    <FilterBaseComposition
      {...props}
      getDescription={getDescription}
      getQueryFilters={getQueryFilters}
      renderPopout={renderPopout}
    />
  );
};

export default FilterBigDecimalComposition;
